import AppHeaders          from './../classes/Headers.js';
import fetch               from 'isomorphic-fetch';
import cookie              from 'react-cookie';
import { getConfig }       from './../classes/Config';
import { calculateNearBy } from './../classes/Distance';

import { receiveUser }              from './UserAction';
import { receiveAssets }            from './AssetsAction';
import { receivePages }             from './PagesAction';
import { receiveFilters, filterPlaces,
    setFilter, FILTER_ALL }         from './FilterAction';
import { setPlaces }                from './PlacesAction';

export const REQUEST_DATA = 'REQUEST_DATA';
export const RECEIVE_DATA = 'RECEIVE_DATA';

const receiveData = (data) => {
    return (dispatch) =>
    {
        dispatch({ type: RECEIVE_DATA });
        let userObject = data.user.data;
        cookie.save('user', userObject.id, { path: '/', expires: new Date('2026'), httpOnly: false });

        dispatch(receiveUser(userObject));
        dispatch(receiveAssets(data.assets.data));
        dispatch(receivePages(data.pages.data));
        dispatch(receiveFilters(data.filters.data, data.tags.data));

        new Promise(
            (resolve) => {
                resolve(calculateNearBy(data.places.data));
            })
            .then((places) => {
                dispatch(setPlaces(places));
                return places;
            })
            .then((places) => {
                dispatch(filterPlaces(places));
            })
            .then(() => {
                dispatch(setFilter(FILTER_ALL))
            });
    }
};

const fetchData = () => {
    return (dispatch, getState) =>
    {
        let body, method;
        let userId = cookie.load('user');

        if (typeof userId !== 'undefined')
        {
            method = 'POST';
            body   = JSON.stringify({ user: userId });
        }
        else
        {
            method = 'GET';
        }

        let auth    = getState().auth;
        let headers = new AppHeaders().getHeaders(auth.token);

        const DataRequest = new Request(getConfig('API_ROOT') + '/data', {
            method : method,
            mode   :'cors',
            body   : body,
            headers: headers
        });

        dispatch({ type: REQUEST_DATA });

        return fetch(DataRequest)
            .then(response => response.json())
            .then(json => dispatch(receiveData(json.data)));
    }
};

const shouldFetchData = (state) =>
{
    if (!state.data.fetched && null !== state.auth.token)
    {
        return true
    }
    else if (state.data.isFetching)
    {
        return false
    }
    else
    {
        return state.data.didInvalidate
    }
};

export const fetchDataIfNeeded = () =>
{
    return (dispatch, getState) => {
        if (shouldFetchData(getState()))
        {
            return dispatch(fetchData())
        }
        else
        {
            return Promise.resolve()
        }
    }
};


// WEBPACK FOOTER //
// ./src/actions/DataAction.js